import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { contact, navItems, services } from '../../data/site';
import { Container } from '../ui/Container';
import { Logo } from '../ui/Logo';

export function Footer() {
  return (
    <footer className="bg-brand-900 text-white">
      <Container className="grid gap-10 py-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Link to="/" aria-label="Spitertech Solutions LLP home">
            <Logo theme="light" />
          </Link>
          <p className="mt-5 max-w-md text-sm leading-6 text-brand-100">
            Enterprise software, mobile applications, ecommerce platforms, cloud services, and low-code automation for teams that need practical digital growth.
          </p>
          <div className="mt-6 space-y-3 text-sm text-brand-100">
            <p className="flex gap-3">
              <Phone aria-hidden="true" className="h-5 w-5 shrink-0 text-accent" />
              <a href={`tel:${contact.phone.replace(/\s/g, '')}`}>{contact.phone}</a>
            </p>
            <p className="flex gap-3">
              <Mail aria-hidden="true" className="h-5 w-5 shrink-0 text-accent" />
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </p>
            <p className="flex gap-3">
              <MapPin aria-hidden="true" className="h-5 w-5 shrink-0 text-accent" />
              <span>{contact.address}</span>
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-brand-100">Company</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link className="text-brand-100 transition hover:text-white" to={item.href}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-brand-100">Services</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {services.slice(0, 5).map((service) => (
              <li key={service.title}>
                <Link className="text-brand-100 transition hover:text-white" to="/services">
                  {service.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10">
        <Container className="flex flex-col justify-between gap-3 py-5 text-xs text-brand-100 sm:flex-row">
          <p>© {new Date().getFullYear()} Spitertech Solutions LLP. All rights reserved.</p>
          <p>Built for accessibility, performance, and sustainable growth.</p>
        </Container>
      </div>
    </footer>
  );
}
